import { MailingId } from 'modules/mailing/types/mailing-interface'
import React from 'react'
import EditorBlock from 'shared/components/dashboard-mail-editor/components/editor-block'
import { useMailingState } from 'shared/components/dashboard-mail-editor/hooks/use-mailing-state'
import { useUnsavedEmail } from 'shared/components/dashboard-mail-editor/hooks/use-unsaved-email'
import { twJoin } from 'tailwind-merge'

interface SplitTestEditorBlockProps {
  variantA: ReturnType<typeof useMailingState>
  variantB: ReturnType<typeof useMailingState>
  unsavedDataVariantA: ReturnType<typeof useUnsavedEmail>
  unsavedDataVariantB: ReturnType<typeof useUnsavedEmail>
  isLoading: boolean
  disabled: boolean
  selectedVariantId: MailingId
}

export function SplitTestEditorBlock({
  selectedVariantId,
  variantA,
  variantB,
  unsavedDataVariantB,
  unsavedDataVariantA,
  isLoading,
  disabled,
}: SplitTestEditorBlockProps) {
  const isVariantASelected = selectedVariantId === variantA.mailing.id

  return (
    <>
      <EditorBlock
        className={twJoin('rounded-tl-none')}
        isSwitchEditorButtonShown
        isPreFetching={isLoading}
        disabled={disabled}
        tempState={isVariantASelected ? variantA.tempState : variantB.tempState}
        onChangeEmail={isVariantASelected ? variantA.onChangeEmail : variantB.onChangeEmail}
        errors={isVariantASelected ? variantA.errors : variantB.errors}
        mailingId={isVariantASelected ? variantA.mailing.id : variantB.mailing.id}
      />
      {isVariantASelected
        ? unsavedDataVariantA.UnsavedEmailConfirmationModal
        : unsavedDataVariantB.UnsavedEmailConfirmationModal}
    </>
  )
}
